// Zenshroom — scripts propios (vanilla, sin librerías externas)
document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initComparador();
  initFaq();
  initGaleriaProducto();
  initVariantesProducto();
  initCantidad();
});

// ---------- Reveals al hacer scroll ----------
function initReveal() {
  var els = document.querySelectorAll('.zs-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('zs-visible'); });
    return;
  }
  var obs = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('zs-visible');
          obs.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
  );
  els.forEach(function (el) { obs.observe(el); });
}

// ---------- Comparador antes/después ----------
function initComparador() {
  var wraps = document.querySelectorAll('[data-zs-comparador]');
  wraps.forEach(function (wrap) {
    var pos = 50;
    function set(p) {
      pos = Math.min(96, Math.max(4, p));
      wrap.style.setProperty('--zs-clip', pos + '%');
    }
    function fromEvent(e) {
      var rect = wrap.getBoundingClientRect();
      var clientX = e.touches ? e.touches[0].clientX : e.clientX;
      var p = ((clientX - rect.left) / rect.width) * 100;
      set(p);
    }
    var dragging = false;
    wrap.addEventListener('pointerdown', function (e) { dragging = true; fromEvent(e); });
    window.addEventListener('pointermove', function (e) { if (dragging) fromEvent(e); });
    window.addEventListener('pointerup', function () { dragging = false; });
    wrap.addEventListener('click', fromEvent);
    set(50);
  });
}

// ---------- Acordeón FAQ ----------
function initFaq() {
  var items = document.querySelectorAll('.zs-faq-item');
  items.forEach(function (item) {
    var btn = item.querySelector('.zs-faq-pregunta');
    var panel = item.querySelector('.zs-faq-respuesta');
    if (!btn || !panel) return;
    btn.addEventListener('click', function () {
      var abierto = item.classList.contains('zs-abierto');
      items.forEach(function (i) {
        i.classList.remove('zs-abierto');
        var p = i.querySelector('.zs-faq-respuesta');
        if (p) p.style.maxHeight = null;
      });
      if (!abierto) {
        item.classList.add('zs-abierto');
        panel.style.maxHeight = panel.scrollHeight + 'px';
      }
    });
  });
}

// ---------- Galería de producto (miniaturas) ----------
function initGaleriaProducto() {
  var principal = document.querySelector('[data-zs-galeria-principal]');
  var minis = document.querySelectorAll('[data-zs-miniatura]');
  if (!principal || !minis.length) return;
  minis.forEach(function (mini) {
    mini.addEventListener('click', function () {
      var src = mini.getAttribute('data-full');
      var img = principal.querySelector('img');
      if (img && src) img.src = src;
      minis.forEach(function (m) { m.classList.remove('zs-activa'); });
      mini.classList.add('zs-activa');
    });
  });
}

// ---------- Selector de variantes ----------
function initVariantesProducto() {
  var form = document.getElementById('zs-producto-form');
  if (!form) return;
  var dataEl = document.querySelector('[data-zs-variantes-json]');
  if (!dataEl) return;
  var variantes;
  try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }

  var pillGroups = form.querySelectorAll('[data-zs-opcion]');
  var idInput = form.querySelector('input[name="id"]');
  var precioActual = document.querySelector('[data-zs-precio-actual]');
  var precioAntes = document.querySelector('[data-zs-precio-antes]');
  var botonAnadir = form.querySelector('[data-zs-anadir]');

  function seleccionActual() {
    var sel = [];
    pillGroups.forEach(function (group) {
      var activa = group.querySelector('.zs-seleccionada');
      sel.push(activa ? activa.getAttribute('data-valor') : null);
    });
    return sel;
  }

  function formatoDinero(cents) {
    return (cents / 100).toLocaleString(document.documentElement.lang || 'es', {
      style: 'currency',
      currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD',
    });
  }

  function actualizar() {
    var sel = seleccionActual();
    var match = variantes.find(function (v) {
      return v.options.every(function (opt, i) { return opt === sel[i]; });
    });
    if (!match) return;
    if (idInput) idInput.value = match.id;
    if (precioActual) precioActual.textContent = formatoDinero(match.price);
    if (precioAntes) {
      if (match.compare_at_price && match.compare_at_price > match.price) {
        precioAntes.textContent = formatoDinero(match.compare_at_price);
        precioAntes.style.display = '';
      } else {
        precioAntes.style.display = 'none';
      }
    }
    if (botonAnadir) {
      if (match.available) {
        botonAnadir.disabled = false;
        botonAnadir.textContent = botonAnadir.getAttribute('data-texto-disponible');
      } else {
        botonAnadir.disabled = true;
        botonAnadir.textContent = botonAnadir.getAttribute('data-texto-agotado');
      }
    }
  }

  pillGroups.forEach(function (group) {
    group.querySelectorAll('.zs-producto-pill').forEach(function (pill) {
      pill.addEventListener('click', function () {
        if (pill.disabled) return;
        group.querySelectorAll('.zs-producto-pill').forEach(function (p) { p.classList.remove('zs-seleccionada'); });
        pill.classList.add('zs-seleccionada');
        actualizar();
      });
    });
  });

  actualizar();
}

// ---------- Selector de cantidad ----------
function initCantidad() {
  document.querySelectorAll('[data-zs-cantidad]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    var menos = wrap.querySelector('[data-zs-menos]');
    var mas = wrap.querySelector('[data-zs-mas]');
    if (!input) return;
    function set(v) { input.value = Math.max(1, v); }
    if (menos) menos.addEventListener('click', function () { set(parseInt(input.value || '1', 10) - 1); });
    if (mas) mas.addEventListener('click', function () { set(parseInt(input.value || '1', 10) + 1); });
  });
}
